import * as PIXI from "pixi.js";
import {config} from "../../config";
import {ICurrencySwitcher} from "./ICurrencySwitcher";

export class CurrencySwitcher extends PIXI.Container implements ICurrencySwitcher {

    private readonly VALUE_TEXT_STYLE: any = {
        fontSize: 20,
        fill: "#fff",
        fontFamily: "RobotoCondensedRegular",
    };
    private readonly TITLE_TEXT_STYLE: any = {
        fontSize: 17,
        fill: "#c8c7c7",
        fontFamily: "RobotoCondensedRegular",
        fontWeight: 600,
        letterSpacing: 1.6,
    };
    private readonly TILE_TEXT = "COIN";
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly ARROW_RIGHT_POSITION = new PIXI.Point(130, 37);
    private readonly ARROW_LEFT_POSITION = new PIXI.Point(0, 37);
    private readonly TITLE_POSITION = new PIXI.Point(65, 0);
    private readonly VALUE_POSITION = new PIXI.Point(65, 37);
    private readonly BACKGROUND_WIDTH = 85;

    // private arrowLeftButton: Button;
    // private arrowRightButton: Button;
    private title: PIXI.Text;
    private chosenCurrencyValue: PIXI.Text;
    private chosenCurrency: string;
    private subscribers: Array<Function> = [];

    constructor() {
        super();

        this.createAndAddTitle();
        // this.createAndAddLeftArrow();
        // this.createAndAddRightArrow();
        this.createAndAddValue();
    }

    public getCurrency(): string {
        return this.chosenCurrency;
    }

    public enable(): void {
        // this.arrowRightButton.enabled = true;
        // this.arrowLeftButton.enabled = true;
    }

    public disable(): void {
        // this.arrowRightButton.enabled = false;
        // this.arrowLeftButton.enabled = false;
    }

    public subscribeOnValueChanged(subscriber: Function): void {
        this.subscribers.push(subscriber);
    }

    private createAndAddTitle(): void {
        this.title = new PIXI.Text(this.TILE_TEXT, this.TITLE_TEXT_STYLE);
        this.title.anchor = this.DEFAULT_ANCHOR_POINT;
        this.title.position = this.TITLE_POSITION;
        this.addChild(this.title);
    }

    // private createAndAddLeftArrow(): void {
    //     this.arrowLeftButton = new Button("arrowLeft", "arrowLeftHover", "arrowLeftClick",
    //         "arrowLeftInactive", "buttonClicked");
    //     this.arrowLeftButton.position = this.ARROW_LEFT_POSITION;
    //     this.arrowLeftButton.subscribeOnClicked(this.switchCoin.bind(this));
    //     this.addChild(this.arrowLeftButton);
    // }
    //
    // private createAndAddRightArrow(): void {
    //     this.arrowRightButton = new Button("arrowRight", "arrowRightHover", "arrowRightClick",
    //         "arrowRightInactive", "buttonClicked");
    //     this.arrowRightButton.position = this.ARROW_RIGHT_POSITION;
    //     this.arrowRightButton.subscribeOnClicked(this.switchCoin.bind(this));
    //     this.addChild(this.arrowRightButton);
    // }

    private createAndAddValue(): void {
        this.chosenCurrency = config.baseCurrency;
        this.chosenCurrencyValue = new PIXI.Text(config.displayCurrency, this.VALUE_TEXT_STYLE);
        this.chosenCurrencyValue.anchor = this.DEFAULT_ANCHOR_POINT;
        this.chosenCurrencyValue.position = this.VALUE_POSITION;
        this.addChild(this.chosenCurrencyValue);
    }

    private switchCoin(): void {
        if (this.chosenCurrency === config.baseCurrency) {
            this.chosenCurrency = config.baseCurrency;
        }
        this.chosenCurrencyValue.text = this.chosenCurrency;
        this.callAllSubscribers(this.chosenCurrency);
    }

    private callAllSubscribers(currencyType: string): void {
        for (let i = 0; i < this.subscribers.length; i++) {
            this.subscribers[i](currencyType);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/CurrencySwitcher.ts